import { LoadState } from "../../../constants/enums";
import { getUniqueId } from "../../../helpers";

export interface IBusinessPolicyCoverageExclusionsState {
  data: IBusinessPolicyCoverageExclusion[];
  loading: LoadState;
  coverageExclusion: IBusinessPolicyCoverageExclusion;
  coverageExclusionLoading: LoadState;
  error: string | null;
}

export interface ICoverageExclusionRow {
  key: string;
  coverage_exclusion: string;
}

export interface IBusinessPolicyCoverageExclusion {
  customer_policy_id: number | null;
  coverage_number: number | null;
  risk_location: string | null;
  coverage_exclusions: ICoverageExclusionRow[];
  status: string;
}

export const defaultBusinessPolicyCoverageExclusionsState: IBusinessPolicyCoverageExclusionsState =
  {
    data: [],
    loading: LoadState.NotLoaded,
    coverageExclusion: {
      customer_policy_id: null,
      coverage_number: null,
      risk_location: null,
      coverage_exclusions: [
        {
          key: getUniqueId(),
          coverage_exclusion: "",
        },
      ],
      status: "ACTIVE",
    },
    coverageExclusionLoading: LoadState.NotLoaded,
    error: null,
  };
